module.exports = __webpack_public_path__ + "static/media/arsmaquettepro-black.f3095f83.woff";